const dateFormatter = () => {
  const formatYearMonthJp = (date: Date) => {
    return `${date.getFullYear()}年${date.getMonth() + 1}月`
  }

  return {
    formatYearMonthJp
  }
}

export { dateFormatter }
